import { SmlsInputText } from '@smiles/smiles-ui-kit-react';
import { useTranslation } from 'react-i18next';
import { useMemberData } from 'pages/FirstAccessFlow/context/MemberDataContext';
import React, { useEffect, useState } from 'react';

export function AddressStreetInput() {
  const { handler, formData, setFormEdit } = useMemberData();
  const [value, setValue] = useState<string>('');
  const { t } = useTranslation('redo-register-v2');

  useEffect(() => {
    setValue(formData.streetName);
  }, [handler]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    setFormEdit();
    setValue(inputValue);
    handler({ streetName: inputValue });
  };

  return (
    <SmlsInputText
      textLabel={t('labels.address')}
      value={value}
      onChange={handleChange}
      data-testid="first-access-address-street-input"
    />
  );
}
